import mapboxgl from 'mapbox-gl';
import React, { useState, useEffect, useCallback, useRef }   from 'react';
import { Modal, Button } from 'antd';

import throttle from "lodash.throttle";
import {COUNTRY_COLORS} from '../lib/Const.js'
import ReactLoading from 'react-loading';
import { DownOutlined, UpOutlined, CaretLeftOutlined, CaretRightOutlined } from '@ant-design/icons';
import Map, {
  Layer, Source, ScaleControl, Popup,
  NavigationControl
} from 'react-map-gl';
import { GoogleMap, StreetViewPanorama, LoadScript } from "@react-google-maps/api";
import Marker from "./Marker";

const containerStyle = {
  width: "100%",
  height: "500px"
};

const CRIME_LEVELS = {
  '1': '1. Low Crime',
  '2': '2. Minimal Crime',
  '3': '3. Moderate Crime',
  '4': '4. Elevated Crime',
  '5': '5. High Crime',
}
const raceLabels = {
  'P0090002': 'Hispanic or Latino Population',
  'P0090005': 'White Alone',
  'P0090006': 'Black or African American alone',
  'P0090007': 'American Indian and Alaska Native alone',
  'P0090008': 'Asian Alone',
  'P0090009': 'Native Hawaiian and Other Pacific Islander',
  'P0090010': 'Some Other Race',
  'P0090011': 'Population of two or more races',
  'P0020002': 'Hispanic or Latino Population',
  'P0020005': 'White Alone',
  'P0020006': 'Black or African American alone',
  'P0020007': 'American Indian and Alaska Native alone',
  'P0020008': 'Asian Alone',
  'P0020009': 'Native Hawaiian and Other Pacific Islander',
  'P0020010': 'Some Other Race',
  'P0020011': 'Population of two or more races',
}
const isTouchDevice = 'ontouchstart' in window;
const getSeverityClass = (severity) => {
  if(severity < 2.1) {
    return 1
  }
  if(severity < 7.5) {
    return 2
  }
  if(severity < 14.7) {
    return 3
  }
  if(severity < 24.4) {
    return 4
  }
  return 5
}
const getSeverityColor = (severity) => {
  if(severity === 1) {
    return '#1a9641'
  }
  if(severity === 2) {
    return '#a6d96a'
  }
  if(severity === 3) {
    return '#ffffc0'
  }
  if(severity === 4) {
    return '#fdae61'
  }
  if(severity === 5) {
    return '#d7191c'
  }
  return 'blue'
}
// ['get', 'severity'],
//                   "1.0",
//                   state.crime?.property ? 'hsl(238, 89%, 58%)' : "rgba(0, 0, 255, 0)",
//                   "2.0",
//                   'hsl(156, 76%, 43%)',
//                   "3.0",
//                   'hsl(61, 77%, 54%)',
//                   "4.0",
//                   '#ffff79',
//                   "5.0",
//                   'hsl(0, 86%, 54%)',
//                   'red'
const getSeverityColorForPoint = (severity) => {
  if(severity === "1.0") {
    return 'hsl(238, 89%, 58%)'
  }
  if(severity === "2.0") {
    return 'hsl(156, 76%, 43%)'
  }
  if(severity === "3.0") {
    return 'hsl(61, 77%, 54%)'
  }
  if(severity === "4.0") {
    return '#ffff79'
  }
  if(severity === "5.0") {
    return 'hsl(0, 86%, 54%)'
  }
  return 'red'
}

const BASE_URL = 'https://peoplemaps.us/mapsdata'
// const BASE_URL = 'http://localhost:8080'
const pointInPolygon = require('point-in-polygon');
// 'case',
//                     [">=", ["to-number", ["get", "severity"], 0],  24.4],
//                     '#f40606',
//                     [">=", ["to-number", ["get", "severity"], 0],  14.7],
//                     '#fb7e21',
//                     [">=", ["to-number", ["get", "severity"], 0],  7.5],
//                     '#a4fc3c',
//                     [">=", ["to-number", ["get", "severity"], 0],  2.1],
//                     '#28bceb',
//                     [">=", ["to-number", ["get", "severity"], 0],  0],
//                     '#682882',
//                     'blue'
// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;

function MapContainer(props) {
  const [option, setOption] = useState({
    "type": "vector",
    "tiles": [`${BASE_URL}/tiles/{z}/{x}/{y}.pbf`, ],
    // "tiles": ['http://3.20.79.56:8000/tiles/{z}/{x}/{y}.pbf', ],
    'minzoom': 6,
    'maxzoom': 10
  });
  const SERVRITY = {
    "1": "property",
    "2": "society",
    "3": "person-property",
    "5": "person",
    "4": "simple-assault"
  }
  const [state, setState] = useState({});
  const [center, setCenter] = useState([-90.38277827426225, 37.71859032558816]);
  const [zoom, setZoom] = useState([4]);
  const [highlightedGeometry, setHighlightedGeometry] = useState(null);
  const [highlightPoint, setHighlightPoint] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [helloPopup, setHelloPopup] = useState(true);
  const [showMiniPopup, setShowMiniPopup] = useState(false);
  const [popPoint, setPopPoint] = useState([-90.38277827426225, 37.71859032558816]);
  const [miniPopPoint, setMiniPopPoint] = useState([-90.38277827426225, 37.71859032558816]);
  const [data, setData] = useState([]);
  const [miniData, setMiniData] = useState([]);
  const [raceData, setRaceData] = useState();
  const [incomeData, setIncomeData] = useState();
  const [occupancyData, setOccupancyData] = useState();
  const [raceLevel, setRaceLevel] = useState(1);
  const [loading, setLoading] = useState(false);
  const [isMarker, setIsMarker] = useState(false);
  const [currZoom, setCurrZoom] = useState(4);
  const markerUrl = 'https://peoplemaps.us/mapsdata/static/marker-large.svg'
  const mapRef = useRef(null);
  const [slide, setSlide] = useState(true);
  const [mapLoading, setIsMapLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isStreetView, setIsStreetView] = useState(false);
  const [flagd, setFlagd] = useState(0);
  const [googleMapCenter, setGoogleMapCenter] = useState({
    lat: 37.869085, // Example: Googleplex
    lng: -122.254775
  });
  const fetchData = (bounds) => {
  };
  const [modalRenderKey, setModalRenderKey] = useState(0);

  const isStreetViewRef = useRef(isStreetView);

  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);

  const timeoutsRef = useRef([]);

  useEffect(() => {
    console.log("Screen width:", width);
  }, [width]);

  useEffect(() => {
    isStreetViewRef.current = isStreetView;
  }, [isStreetView]);

  const toogleStreeView = () => {
    const map = mapRef.current;
    if (map) {
      if (isStreetView) {
        map.getCanvas().style.cursor = 'default';
      } else {
        map.getCanvas().style.cursor = 'crosshair';
      }
    }
    setIsStreetView(!isStreetView);
  }
  const handleOk = () => {const map = mapRef.current;
    if (map) {
      map.getCanvas().style.cursor = 'default';
    }
    setIsModalOpen(false);
    setIsStreetView(false);
  };
  const handleCancel = () => setIsModalOpen(false);

  const handleViewportChange = (viewport) => {
    const { latitude, longitude } = viewport;
    const bounds = [
      longitude - 0.1, latitude - 0.1, // Adjust bounding box
      longitude + 0.1, latitude + 0.1
    ];
    fetchData(bounds);
  };
  useEffect(() => {
    /* global fetch */
      //

    const handleEsc = (event) => {
      if (event.key === 'Escape') {
        const map = mapRef.current;
        if (map) {
          map.getCanvas().style.cursor = 'default';
        }
        setIsStreetView(false);
      }
    };

    document.addEventListener('keydown', handleEsc);

    return () => {
      document.removeEventListener('keydown', handleEsc);
    };
  }, []);
  useEffect(() => {
    const prevState = state;
    setState(props.state)
    setShowPopup(false)

    if (mapRef?.current) {
      const map = mapRef?.current
      map.zoomTo(map.getZoom());

      // On-demand fetch: fire only when a layer is first toggled on
      const bbox = map.getBounds().toArray();
      const zoom = map.getZoom();

      if (props.state?.race?.on && !prevState?.race?.on) {
        if (zoom < 6) updateRaceData(map, bbox, 1);
        else if (zoom <= 11) updateRaceData(map, bbox, 2);
        else if (zoom <= 14) updateRaceData(map, bbox, 3);
        else updateRaceData(map, bbox, 4);
      }

      if (props.state?.income?.on && !prevState?.income?.on) {
        if (zoom < 6) updateDataIncome(map, bbox, 0);
        else if (zoom <= 11) updateDataIncome(map, bbox, 1);
        else updateDataIncome(map, bbox, 2);
      }

      if (props.state?.occupancy?.on && !prevState?.occupancy?.on) {
        if (zoom < 6) updateOccupancyData(map, bbox, 0);
        else if (zoom <= 11) updateOccupancyData(map, bbox, 1);
        else updateOccupancyData(map, bbox, 2);
      }
      // if (highlightedGeometry && zoom > 8) {
      //   timeoutsRef.current.forEach(clearTimeout);
      //   timeoutsRef.current = [];
      //   setTimeout(()=>{
      //     setShowPopup(true);
      //     showInfo(highlightPoint, true, false, props.state);
      //     setFlagd(0);
      //   }, 2000)
      // }

      if (isMarker && props.region && props.region.center) {
        setHighlightedGeometry(null);
        setHighlightPoint(null);
        setTimeout(()=>{
          showInfo(props.region.center, true, false, props.state);
          setFlagd(0);
        }, 2000)
      }
    }
  }, [props.state]);

  useEffect(() => {
    setIsMarker(props.isMarker)
  }, [props.isMarker]);

  useEffect(() => {
    if (props.region && mapRef.current) {
      setCenter(props.region.center)
      setIsMarker(true)

      // if(props.region.place_type.includes('region') || props.region.place_type.includes('place')) {
      //   setZoom([12])
      // } else {
      //   setZoom([14])
      // }
      const map = mapRef.current;
      map.flyTo({
        center: props.region.center,
        zoom: 13,
        duration: 1000, // Animation duration in milliseconds
        essential: true, // This animation is considered essential, and will not be affected by browser-level optimizations
      });
      setHighlightedGeometry(null);
      setHighlightPoint(null);
      setTimeout(()=>{
        showInfo(props.region.center, true, false);
        setFlagd(0);
      }, 2000)
      
    }
  }, [props.region, mapRef]);

  const onClickMap = (evt, isClick = true) => {
    showInfo([evt.lngLat.lng, evt.lngLat.lat], isClick)
  }

  const onClickMapR = (evt, isClick = true) => {
    setHighlightedGeometry(null);
    setHighlightPoint(null);
    setIsMarker(false);
    props.setValue('');
    showInfo([evt.lngLat.lng, evt.lngLat.lat], isClick)
  }

  const showInfo = (pt, isClick = true, nozoom = true, tpState=null) => { // [lng, lat]
    const map = mapRef?.current;
    if(!map) return;
    if(isClick && !nozoom) {
      const zoom = map.getZoom()
      setCurrZoom(zoom)
    }
    const layers = {
      'race': 'racedata',
      'income': 'income',
      'occupancy': 'occupancy',
      'voting': 'voting_source',
      'voting2024': 'voting2024_source',
      'crime': ['mapillarysdata', 'tract_source'],
      'ancestry': 'ancestry-source'
    }
    var st = tpState ? tpState : state;
    Object.keys(layers).forEach(key => {
      if(st[key]?.on) {
        const features = map.queryRenderedFeatures(map.project(pt));
        
        let chosenFeatures = features.filter(f => f.source === layers[key] || layers[key].includes(f.source) )
        if(key === 'crime') {
          chosenFeatures = features.filter(f => f.source === 'mapillarysdata')
          if(!chosenFeatures.length) {
            chosenFeatures = features.filter(f => f.source === 'tract_source')
          }
        }
        if(key === 'crime') {
          if(chosenFeatures.length > 0 && chosenFeatures[0].properties.severity) { 
            // sort by severity by descending
            chosenFeatures = chosenFeatures.sort((a, b) => parseFloat(b.properties.severity) - parseFloat(a.properties.severity))
          }
        }
        if(isClick) {
          // how to remove duplicates
          const uniqueFeatures = chosenFeatures.filter((feature, index, self) =>
            index === self.findIndex((t) => t.properties.id === feature.properties.id)
          );
          chosenFeatures = uniqueFeatures;
        }
        console.log(isClick, nozoom, chosenFeatures, flagd, '>>>>>>>>>>>>>')
        if (!nozoom && chosenFeatures.length == 0 && flagd < 20) {
          timeoutsRef.current.forEach(clearTimeout);
          timeoutsRef.current = [];
          const timeoutId = setTimeout(()=>{
            showInfo(props.region ? props.region.center : pt, true, false);
          }, 2000)
          timeoutsRef.current.push(timeoutId);
          setFlagd(flagd+1);
          return;
        }
        if(isClick) {
          // if (zoom <= 8) {
          //   return;
          // }
          setShowPopup(true);
          setHelloPopup(false);
          setShowMiniPopup(false);
          setPopPoint(pt)
          setData(chosenFeatures.map(f => f.properties));
          timeoutsRef.current.forEach(clearTimeout);
          timeoutsRef.current = [];
          setHighlightedGeometry(chosenFeatures[0]);
          setHighlightPoint(pt);
          map.moveLayer("polygon-highlight-outline");
        }
        else {
          if(!showPopup) {
            setShowMiniPopup(true);
            setMiniPopPoint(pt)
            setMiniData(chosenFeatures.map(f => f.properties));
            setHighlightedGeometry(null);
            setHighlightPoint(null);
          }
          else {
            setShowMiniPopup(false);
          }
        }

        if (key == 'voting2024' && zoom <= 6) {
          var flag = false;
          chosenFeatures.map(feature => {
            if (feature.properties.g) {
              flag = true;
            }
          })
          if (flag == false) {
            setShowMiniPopup(false);
            setShowPopup(false);
            
            if (isClick) {
              setHelloPopup(true);
            }
            setHighlightedGeometry(null)
            setHighlightPoint(null);
          }
        };
      }
    })
  }

  const throttledHover = throttle(onClickMap, 1000);

  const updateRaceData = (map, bbox, level) => {
    setIsMapLoading(true);
    const bboxString = bbox.flat().join(',');

    // Encode the string for use in a URL
    const encodedBbox = encodeURIComponent(bboxString);
    let apiUrl = `https://services.arcgis.com/P3ePLMYs2RVChkJx/arcgis/rest/services/USA_Census_2020_DHC_Race_and_Ethnicity/FeatureServer/${level}/query?where=1%3D1&geometry=${encodedBbox}&outFields=P0090007%2C+P0090008%2C+P0090006%2C+P0090002%2C+P0090009%2C+P0090010%2C+P0090011%2C+P0090005%2C+P009_calc_pctAIANa%2C+P009_calc_pctAsiana%2C+P009_calc_pctBa%2C+P009_calc_pctH%2C+P009_calc_pctNHPIa%2C+P009_calc_pctSORa%2C+P009_calc_pctMulti%2C+P009_calc_pctWa&returnGeometry=true&f=geojson`
    if(level === 4) {
      apiUrl = `https://services.arcgis.com/P3ePLMYs2RVChkJx/arcgis/rest/services/USA_Census_2020_Redistricting_Blocks/FeatureServer/0/query?where=1%3D1&geometry=${encodedBbox}&outFields=P0020007%2C+P0020008%2C+P0020006%2C+P0020002%2C+P0020009%2C+P0020010%2C+P0020011%2C+P0020005%2C+PCT_P0020007%2C+PCT_P0020008%2C+PCT_P0020006%2C+PCT_P0020002%2C+PCT_P0020009%2C+PCT_P0020010%2C+PCT_P0020011%2C+PCT_P0020005&returnGeometry=true&f=geojson`
    }

    fetch(apiUrl)
      .then(resp => resp.json())
      .then(json => {
        let geoJson = { ...json };
        geoJson.features.forEach(feature => {
          const properties = feature.properties;
          let maxProperty = '';
          if(level === 4) {
            maxProperty = Object.keys(properties).filter(key => !key.includes('PCT_')).reduce((a, b) => properties[a] > properties[b] ? a : b);
          }
          else {
            maxProperty = Object.keys(properties).filter(key => !key.includes('_calc_')).reduce((a, b) => properties[a] > properties[b] ? a : b);
          }
          feature.properties.maxProperty = maxProperty;
        });
        setRaceData(geoJson)
        map.getSource('racedata').setData(geoJson);
        setIsMapLoading(false);
      })
      .catch(err => console.error('Could not load data', err)); // eslint-disable-line
  }

  // ACS_Median_Income_by_Race_and_Age_Selp_Emp_Boundaries
  const updateDataIncome = (map, bbox, level) => {
    setIsMapLoading(true);
    const bboxString = bbox.flat().join(',');

    // Encode the string for use in a URL
    const encodedBbox = encodeURIComponent(bboxString);
    fetch(
      `https://services.arcgis.com/P3ePLMYs2RVChkJx/ArcGIS/rest/services/ACS_Median_Household_Income_View_Boundaries/FeatureServer/${level}/query?where=1%3D1&geometry=${encodedBbox}&outFields=OBJECTID,GEOID,B19049_001E&returnGeometry=true&f=geojson`
    )
      .then(resp => resp.json())
      .then(json => {
        setIncomeData(json)
        map.getSource('income').setData(json);
        setIsMapLoading(false);
      })
      .catch(err => console.error('Could not load data', err)); // eslint-disable-line
  }
  const updateOccupancyData = (map, bbox, level) => {
    setIsMapLoading(true);
    const bboxString = bbox.flat().join(',');

    // https://services.arcgis.com/P3ePLMYs2RVChkJx/ArcGIS/rest/services/ACS_Household_Size_Boundaries/FeatureServer/${level}/query?where=1%3D1&outFields=B25010_001E&geometry=${encodedBbox}&returnGeometry=true&f=geojson

    // Encode the string for use in a URL
    const encodedBbox = encodeURIComponent(bboxString);
    fetch(
      `https://services.arcgis.com/P3ePLMYs2RVChkJx/ArcGIS/rest/services/ACS_Household_Size_View_Boundaries/FeatureServer/${level}/query?where=1%3D1&outFields=B25010_001E&geometry=${encodedBbox}&geometryPrecision=5&returnGeometry=true&f=geojson`
    )
      .then(resp => resp.json())
      .then(json => {
        setOccupancyData(json)
        map.getSource('occupancy').setData(json);
        setIsMapLoading(false);
      })
      .catch(err => console.error('Could not load data', err)); // eslint-disable-line
  }
  
  const onZoom = (evt) => {
    const map = mapRef?.current
    setZoom(map.getZoom())
    const race = document.getElementById('race')
    const income = document.getElementById('income')
    const occupancy = document.getElementById('occupancy')
    const bbox = map.getBounds().toArray()
    const zoom = map.getZoom()
    
    if (!evt.fitboundUpdate && race) {
      if(zoom < 6) {
        updateRaceData(map, bbox, 1)
      }
      if(zoom >= 6 && zoom <= 11) {
        updateRaceData(map, bbox, 2)
      }
      if(zoom > 11 && zoom <= 14) {
        updateRaceData(map, bbox, 3)
      }
      if(zoom > 14) {
        updateRaceData(map, bbox, 4)
      }
    }
    if (!evt.fitboundUpdate && income) {
      if(zoom < 6) {
        updateDataIncome(map, bbox, 0)
      }
      if(zoom >= 6 && zoom <= 11) {
        updateDataIncome(map, bbox, 1)
      }
      if(zoom > 11) {
        updateDataIncome(map, bbox, 2)
      }
    }
    if (!evt.fitboundUpdate && occupancy) {
      if(zoom < 6) {
        updateOccupancyData(map, bbox, 0)
      }
      if(zoom >= 6 && zoom <= 11) {
        updateOccupancyData(map, bbox, 1)
      }
      if(zoom > 11) {
        updateOccupancyData(map, bbox, 2)
      }
    }
  }

  const getAncestryColors = (colors, progress) => {
    let fillColor = ['match',
      ['get', 'FirAHRName'],
      'P0090002',
      '#fb9902',
    ]
    Object.keys(colors).forEach(key => {
      fillColor.push(key);
      fillColor.push(colors[key])
    })
    fillColor.push('transparent')
    let res = {
      'fill-color': fillColor,
      'fill-outline-color': 'rgba(128, 128, 128, 0.1)',
      'fill-opacity': 0.3
    }
    return res
  }

  const getIncomeColor = (value) => {
    if (value >= 121000) {
      return "#d6a41a"
    } else if (value >= 84800) {
      return "#3a8059"
    } else if (value >= 48600) {
      return "#85bf9b"
    } else if (value >= 12400) {
      return "#8a8fbf"
    } else if (value >= 0) {
      return "#434e96"
    } 
  }

  const getOccupancyColor = (value) => {
    if (value >= 4) {
      return "#f50000"
    } else if (value >= 3) {
      return "#f53d00"
    } else if (value >= 2) {
      return "#f57a00"
    } else if (value >= 1) {
      return "#f5b800"
    } else if (value >= 0) {
      return "#f5f500"
    } 
  }

  const handleMouseDown = (e) => {
    if (!isStreetViewRef.current) {
      return;
    }

    setIsStreetView(false);
    document.body.style.cursor = 'default';
    console.log('Mouse down on map at:', e.lngLat);
    setGoogleMapCenter({
      lat: e.lngLat.lat,
      lng: e.lngLat.lng
    })
    setModalRenderKey(prev => prev + 1);
    setIsModalOpen(true);
    // e.lngLat.lng, e.lngLat.lat
  };

  const handleMapLoad = useCallback((event) => {
    const map = event.target;
    mapRef.current = map;

    // Example: Log map bounds after the map loads
    const bounds = map.getBounds();
    console.log('Map bounds:', bounds);
    setIsMapLoading(false)
    // console.log('MapLoaded')

    // Event listener for vector tile loading
    const handleSourceData = (event) => {
      // console.log('LayerLoad:', event.sourceDataType, map.isSourceLoaded('my-source'))
      if (event.sourceDataType === 'visibility' && !map.isSourceLoaded('my-source')) {
        setIsMapLoading(true);
      } else {
        setIsMapLoading(false);
      }
    };

    // Attach event listeners
    map.on('sourcedata', handleSourceData);
    map.on('data', handleSourceData);
    map.on('mousedown', handleMouseDown);

    // Cleanup event listeners on unmount
    return () => {
      map.off('sourcedata', handleSourceData);
      map.off('data', handleSourceData);
      map.off('mousedown', handleMouseDown);
    };
  }, []);
  useEffect(() => {
    
  }, [mapRef]);
  const renderMapKey = (type) => {
    if (type == 'crime') {
      return <div className='map-key-content'>
        <div className='map-key-label'>Map Key (Crime)</div>
        <div>
          <div className={`popup-header map-key-icon`} style={{backgroundColor: 'hsl(238, 89%, 58%)'}}></div>
          <div className='map-key-title'>Property</div>
        </div>
        <div>
          <div className={`popup-header map-key-icon`} style={{backgroundColor: 'hsl(156, 76%, 43%)'}}></div>
          <div className='map-key-title'>Society</div>
        </div>
        <div>
          <div className={`popup-header map-key-icon`} style={{backgroundColor: 'hsl(0, 86%, 54%)'}}></div>
          <div className='map-key-title'>Person</div>
        </div>
        <div>
          <div className={`popup-header map-key-icon`} style={{backgroundColor: 'hsl(61, 77%, 54%)'}}></div>
          <div className='map-key-title'>Person Property</div>
        </div>
        <div>
          <div className={`popup-header map-key-icon`} style={{backgroundColor: '#ffff79'}}></div>
          <div className='map-key-title'>Simple Assault</div>
        </div>
      </div>
    }
    if (type == 'ancestry') {
      let countries = Object.keys(COUNTRY_COLORS).sort()
      return <div className='map-key-content'>
        <div className='map-key-label'>Map Key (Ancestry)</div>
        {countries.map(cn => {
          return <div>
            <div className={`popup-header map-key-icon`} style={{backgroundColor: COUNTRY_COLORS[cn]}}></div>
            <div className='map-key-title'>{cn}</div>
          </div>
        })}
      </div>
    }
    if (type == 'race') {
      return <div className='map-key-content'>
        <div className='map-key-label'>Map Key (Race)</div>
        {Object.keys(raceLabels).map(key => {
          return <div>
            <div className={`popup-header map-key-icon ${key}`}></div>
            <div className='map-key-title'>{ raceLabels[key] }</div>
          </div>
        })}
        <div>
          <div className={`popup-header map-key-icon other`}></div>
          <div className='map-key-title'>Unreported</div>
        </div>
      </div>
    }
    if (type == 'voting') {
      return <div className='map-key-content'>
        <div className='map-key-label'>Map Key (Voting 2020)</div>
        <div>
          <div className={`popup-header map-key-icon color-blue`}></div>
          <div className='map-key-title'>Joseph Biden</div>
        </div>
        <div>
          <div className={`popup-header map-key-icon color-red`}></div>
          <div className='map-key-title'>Donald Trump</div>
        </div>
      </div>
    }
    if (type == 'voting2024') {
      return <div className='map-key-content'>
        <div className='map-key-label'>Map Key (Voting 2024)</div>
        <div>
          <div className={`popup-header map-key-icon color-blue`}></div>
          <div className='map-key-title'>Kamala Harris</div>
        </div>
        <div>
          <div className={`popup-header map-key-icon color-red`}></div>
          <div className='map-key-title'>Donald Trump</div>
        </div>
      </div>
    }
    if (type == 'income') {
      return <div className='map-key-content'>
        <div className='map-key-label'>Map Key (Income)</div>
        <div>
          <div className={`popup-header map-key-icon`} style={{backgroundColor: "#d6a41a"}}></div>
          <div className='map-key-title'>&#62; $121,000</div>
        </div>
        <div>
          <div className={`popup-header map-key-icon`} style={{backgroundColor: "#3a8059"}}></div>
          <div className='map-key-title'>$84,800 - $121,000</div>
        </div>
        <div>
          <div className={`popup-header map-key-icon`} style={{backgroundColor: "#85bf9b"}}></div>
          <div className='map-key-title'>$48,600 - $84,800</div>
        </div>
        <div>
          <div className={`popup-header map-key-icon`} style={{backgroundColor: "#8a8fbf"}}></div>
          <div className='map-key-title'>$12,400 - $48.600</div>
        </div>
        <div>
          <div className={`popup-header map-key-icon`} style={{backgroundColor: "#434e96"}}></div>
          <div className='map-key-title'>&#60; $12,400</div>
        </div>
      </div>
    }
    if (type == 'occupancy') {
      return <div className='map-key-content'>
        <div className='map-key-label'>Map Key (Household Size)</div>
        <div>
          <div className={`popup-header map-key-icon`} style={{backgroundColor: "#f50000"}}></div>
          <div className='map-key-title'>&#62; 4</div>
        </div>
        <div>
          <div className={`popup-header map-key-icon`} style={{backgroundColor: "#f53d00"}}></div>
          <div className='map-key-title'>3 - 4</div>
        </div>
        <div>
          <div className={`popup-header map-key-icon`} style={{backgroundColor: "#f57a00"}}></div>
          <div className='map-key-title'>2 - 3</div>
        </div>
        <div>
          <div className={`popup-header map-key-icon`} style={{backgroundColor: "#f5b800"}}></div>
          <div className='map-key-title'>1 - 2</div>
        </div>
        <div>
          <div className={`popup-header map-key-icon`} style={{backgroundColor: "#f5f500"}}></div>
          <div className='map-key-title'>0 - 1</div>
        </div>
      </div>
    }
    return <div></div>
  }
  const raceMapping = {
    'P0090002': 'P009_calc_pctH',
    'P0090005': 'P009_calc_pctWa',
    'P0090006': 'P009_calc_pctBa',
    'P0090007': 'P009_calc_pctAIANa',
    'P0090008': 'P009_calc_pctAsiana',
    'P0090009': 'P009_calc_pctNHPIa',
    'P0090010': 'P009_calc_pctSORa',
    'P0090011': 'P009_calc_pctMulti',
    'P0020002': 'PCT_P0020002',
    'P0020005': 'PCT_P0020005',
    'P0020006': 'PCT_P0020006',
    'P0020007': 'PCT_P0020007',
    'P0020008': 'PCT_P0020008',
    'P0020009': 'PCT_P0020009',
    'P0020010': 'PCT_P0020010',
    'P0020011': 'PCT_P0020011',
  }
  const MiniPopupContent = ({ data }) => (
    <>
    { state.voting?.on && !state.voting2024?.on && !state.race?.on && data && <div className={`popup-header ${data.pct_dem_lead > 0 ? 'color-blue' : 'color-red'}`}>
      Precinct: {state.voting?.on && data.geoid}
      <p style={{color: 'black', textAlign: 'center', fontSize: '8px', marginBottom: 0}}>(Click for more details)</p>
    </div>}
    { state.voting?.on && state.voting2024?.on && !state.race?.on && data && data.g && <div className={`popup-header ${(data.D24 - data.R24) > 0 ? 'color-blue' : 'color-red'}`}>
      { data.g && `Precinct: ${state.voting?.on && data.g }`}
      <p style={{color: 'black', textAlign: 'center', fontSize: '8px', marginBottom: 0}}>(Click for more details)</p>
    </div>}
    { state.voting?.on && !state.voting2024?.on && !state.race?.on && data && <div className='popup-body'>
      <div>
        <span className='d-title'>Joseph Biden:</span>
        <span>{data.votes_dem}</span>
      </div>
      <div>
        <span className='d-title'>Donald Trump:</span>
        <span>{data.votes_rep}</span>
      </div>
      <div>
        <span className='d-title'>Total:</span>
        <span>{data.votes_total}</span>
      </div>
      <div>
        <span className='d-title'>Percent Dem Lead:</span>
        <span>{data.pct_dem_lead}%</span>
      </div>
    </div>}
    { state.voting?.on && state.voting2024?.on && !state.race?.on && data && data.g && <div className='popup-body'>
      <div>
        <span className='d-title'>Kamala Harris:</span>
        <span>{data.D24}</span>
      </div>
      <div>
        <span className='d-title'>Donald Trump:</span>
        <span>{data.R24}</span>
      </div>
      <div>
        <span className='d-title'>Total:</span>
        <span>{data.T24}</span>
      </div>
      <div>
        <span className='d-title'>Percent Dem Lead:</span>
        <span>{parseInt((data.D24 - data.R24) * 100 / data.T24)}%</span>
      </div>
    </div>}
    { state.crime?.on && data && data.weighted_count >= 0 && 
    <>
      <div style={{backgroundColor: getSeverityColor(getSeverityClass(data.severity)), padding: 5, color: 'black', textAlign: 'center', fontWeight: 'bold', fontSize: '14px'}}>
        Census Tract No. {data.tract}
        <br/>
        <small>(Click for more details)</small>
      </div>
    </>
    }
    { state.crime?.on && data && data.id && <div style={{backgroundColor: getSeverityColorForPoint(data.severity)}} className={`popup-header ${SERVRITY[data.incident_offense_code] ? SERVRITY[data.incident_offense_code] : ''}`}>
      {data.incident_offense_code == "4" ? "Simple Assault" : data.incident_source_original_type}
      <p style={{color: 'black', textAlign: 'center', fontSize: '8px', marginBottom: 0}}>(Click for more details)</p>
    </div>}
    { state.crime?.on && data && data.id && <div className='popup-body' style={{width: 400}}>
      <div>
        <span className='d-title'>Incident Date:</span>
        <span>{new Date(data.incident_date).toLocaleString()}</span>
      </div>
      <div>
        <span className='d-title'>Incident Offense:</span>
        <span>{data.incident_offense}</span>
      </div>
      <div>
        <span className='d-title'>Incident Offense Description:</span>
        <span>{data.incident_offense_description}</span>
      </div>
      <div>
        <span className='d-title'>Incident Offense Detail Description:</span>
        <span>{data.incident_offense_detail_description}</span>
      </div>
      <div>
        <span className='d-title'>Incident Offense Crime Against:</span>
        <span>{data.incident_offense_crime_against}</span>
      </div>
      <div>
        <span className='d-title'>Incident Offense Action:</span>
        <span>{data.incident_offense_action}</span>
      </div>
      <div>
        <span className='d-title'>Incident Source Name:</span>
        <span>{data.incident_source_name}</span>
      </div>
      <div>
        <span className='d-title'>Incident Address:</span>
        <span>{data.incident_address}</span>
      </div>
    </div>}
    { state.race?.on && data && <div className={`popup-race popup-header ${data['maxProperty'] ? data['maxProperty'] : ''}`}>
      {raceLabels[data['maxProperty']]} - {data[raceMapping[data['maxProperty']]]}%
      <p style={{color: 'black', textAlign: 'center', fontSize: '8px', marginBottom: 0}}>(Click for more details)</p>
    </div>}

    { state.ancestry?.on && data && data.TAHRPCT != 0 && <div className={`popup-race popup-header`} style={{backgroundColor: COUNTRY_COLORS[data.FirAHRName]}}>
      {data.NAME}
      {/* <button onClick={()=>setShowPopup(false)} className='close-btn'>X</button> */}
      <div className="mt-1 mb-1" style={{fontSize: '10px'}}>
        <span className='d-color' style={{backgroundColor: COUNTRY_COLORS[data.FirAHRName]}}></span>
        <span className='d-title'>{data.FirAHRName}:</span>
        <span>{(data.TAHRPCT * 100).toFixed(1)}%</span>
      </div>
      <p style={{color: 'black', textAlign: 'center', fontSize: '8px', marginBottom: 0}}>(Click for more details)</p>
    </div>}

    {state.ancestry?.on && data && data.TAHRPCT == 0 && <div className="popup-header">Data Unavailable for this Area</div>}

    { state.income?.on && data && <div className={`popup-race popup-header`} style={{backgroundColor: getIncomeColor(data['B19049_001E'])}}>
      Median Household Income (2020)
      <p style={{color: 'black', textAlign: 'center', fontSize: '8px', marginBottom: 0}}>(Click for more details)</p>
    </div>}
    { state.income?.on && data && <div className='popup-body race-body'>
      <div>
        <span className='d-title'>Median Income:</span>
        <span>{parseFloat(data['B19049_001E']).toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
        })}</span>
      </div>
    </div>}

    { state.occupancy?.on && data && <div className={`popup-race popup-header`} style={{backgroundColor: getOccupancyColor(data['B25010_001E'])}}>
      Household Size
      <p style={{color: 'black', textAlign: 'center', fontSize: '8px', marginBottom: 0}}>(Click for more details)</p>
    </div>}
    { state.occupancy?.on && data && <div className='popup-body race-body'>
      <div>
        <span className='d-title'>Size:</span>
        <span>{data['B25010_001E']}</span>
      </div>
      </div>
    }
    {/* <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-around', marginBottom: 2}}>
      <button onClick={() => {
        setData(miniData);
        setShowMiniPopup(false);
        setShowPopup(true);
      }} style={{cursor: "pointer"}}>More Details</button>
    </div> */}
    
    </>
  )
  const PopupContent = ({ data }) => (
    <>
    
    { state.voting?.on && !state.voting2024?.on && !state.race?.on && data && <div className={`popup-header mapkey-header ${data.pct_dem_lead > 0 ? 'color-blue' : 'color-red'}`}>
      Precinct: {state.voting?.on && data.geoid}
    </div>}
    { state.voting?.on && state.voting2024?.on && !state.race?.on && data && data.g && <div className={`popup-header mapkey-header ${(data.D24 - data.R24) > 0 ? 'color-blue' : 'color-red'}`}>
      Precinct: {state.voting?.on && data.g }
    </div>}
    { state.voting?.on && !state.voting2024?.on && !state.race?.on && data && <div className='popup-body mapkey-body'>
      <div>
        <span className='d-title'>Joseph Biden:</span>
        <span>{data.votes_dem}</span>
      </div>
      <div>
        <span className='d-title'>Donald Trump:</span>
        <span>{data.votes_rep}</span>
      </div>
      <div>
        <span className='d-title'>Total:</span>
        <span>{data.votes_total}</span>
      </div>
      <div>
        <span className='d-title'>Percent Dem Lead:</span>
        <span>{data.pct_dem_lead}%</span>
      </div>
    </div>}
    { state.voting?.on && state.voting2024?.on && !state.race?.on && data && data.g && <div className='popup-body mapkey-body'>
      <div>
        <span className='d-title'>Kamala Harris:</span>
        <span>{data.D24}</span>
      </div>
      <div>
        <span className='d-title'>Donald Trump:</span>
        <span>{data.R24}</span>
      </div>
      <div>
        <span className='d-title'>Total:</span>
        <span>{data.T24}</span>
      </div>
      <div>
        <span className='d-title'>Percent Dem Lead:</span>
        <span>{parseInt((data.D24 - data.R24) * 100 / data.T24)}%</span>
      </div>
    </div>}
    { state.crime?.on && data.weighted_count >= 0  && <div style={{backgroundColor: getSeverityColor(getSeverityClass(data.severity)), fontSize: "16px", paddingTop: 10, paddingBottom: 10}} className={`popup-header mapkey-header ${SERVRITY[data.incident_offense_code] ? SERVRITY[data.incident_offense_code] : ''}`}>
      Census Tract No. {data.tract}
    </div>}
    { state.crime?.on && data && data.id &&  <div style={{backgroundColor: getSeverityColorForPoint(data.severity)}} className={`popup-header mapkey-header ${SERVRITY[data.incident_offense_code] ? SERVRITY[data.incident_offense_code] : ''}`}>
      {data.incident_offense_code == "4" ? "Simple Assault" : data.incident_source_original_type}
      {/* <button onClick={()=>setShowPopup(false)} className='close-btn'>X</button> */}
    </div>}
    { state.crime?.on && data.weighted_count >=0  && <div className='popup-body mapkey-body'>
      {/* <div>
        <span className='d-title'>State ID:</span>
        <span>{data.state}</span>
      </div>
      <div>
        <span className='d-title'>County ID:</span>
        <span>{data.county}</span>
      </div> */}
      <div>
        <span className='d-title'>Severity Score:</span>
        <span>{data.severity.toFixed(2)}</span>
      </div>
      <div>
        <span className='d-title'>Severity Class:</span>
        <span>{getSeverityClass(data.severity)}</span>
      </div>
      <div>
        <span className='d-title'>Crime Point Count:</span>
        <span>{data.point_count}</span>
      </div>
      <div>
        <span className='d-title'>Population:</span>
        <span>{data.population}</span>
      </div>
    </div>}
    { state.crime?.on && data.id && <div className='popup-body mapkey-body'>
      <div>
        <span className='d-title'>Incident Date:</span>
        <span>{new Date(data.incident_date).toLocaleString()}</span>
      </div>
      <div>
        <span className='d-title'>Incident Offense:</span>
        <span>{data.incident_offense}</span>
      </div>
      <div>
        <span className='d-title'>Incident Offense Description:</span>
        <span>{data.incident_offense_description}</span>
      </div>
      <div>
        <span className='d-title'>Incident Offense Detail Description:</span>
        <span>{data.incident_offense_detail_description}</span>
      </div>
      <div>
        <span className='d-title'>Incident Offense Crime Against:</span>
        <span>{data.incident_offense_crime_against}</span>
      </div>
      <div>
        <span className='d-title'>Incident Offense Action:</span>
        <span>{data.incident_offense_action}</span>
      </div>
      <div>
        <span className='d-title'>Incident Source Name:</span>
        <span>{data.incident_source_name}</span>
      </div>
      <div>
        <span className='d-title'>Incident Address:</span>
        <span>{data.incident_address}</span>
      </div>
    </div>}
    { state.race?.on && data && <div className={`popup-race popup-header mapkey-header ${data['maxProperty'] ? data['maxProperty'] : ''}`}>
      {raceLabels[data['maxProperty']]}
      {/* <button onClick={()=>setShowPopup(false)} className='close-btn'>X</button> */}
    </div>}
    { state.race?.on && data && zoom <= 14 && <div className='popup-body race-body mapkey-body'>
      <div>
        <span className='d-title'>{raceLabels['P0090002']}:</span>
        <span>{data['P009_calc_pctH']}%</span>
      </div>
      <div>
        <span className='d-title'>{raceLabels['P0090005']}:</span>
        <span>{data['P009_calc_pctWa']}%</span>
      </div>
      <div>
        <span className='d-title'>{raceLabels['P0090006']}:</span>
        <span>{data['P009_calc_pctBa']}%</span>
      </div>
      <div>
        <span className='d-title'>{raceLabels['P0090007']}:</span>
        <span>{data['P009_calc_pctAIANa']}%</span>
      </div>
      <div>
        <span className='d-title'>{raceLabels['P0090008']}:</span>
        <span>{data['P009_calc_pctAsiana']}%</span>
      </div>
      <div>
        <span className='d-title'>{raceLabels['P0090009']}:</span>
        <span>{data['P009_calc_pctNHPIa']}%</span>
      </div>
      <div>
        <span className='d-title'>{raceLabels['P0090010']}:</span>
        <span>{data['P009_calc_pctSORa']}%</span>
      </div>
      <div>
        <span className='d-title'>{raceLabels['P0090011']}:</span>
        <span>{data['P009_calc_pctMulti']}%</span>
      </div>
    </div>}
    { state.race?.on && data && zoom > 14 &&  <div className='popup-body race-body mapkey-body'>
      <div>
        <span className='d-title'>{raceLabels['P0020002']}:</span>
        <span>{data['PCT_P0020002']}%</span>
      </div>
      <div>
        <span className='d-title'>{raceLabels['P0020005']}:</span>
        <span>{data['PCT_P0020005']}%</span>
      </div>
      <div>
        <span className='d-title'>{raceLabels['P0020006']}:</span>
        <span>{data['PCT_P0020006']}%</span>
      </div>
      <div>
        <span className='d-title'>{raceLabels['P0020007']}:</span>
        <span>{data['PCT_P0020007']}%</span>
      </div>
      <div>
        <span className='d-title'>{raceLabels['P0020008']}:</span>
        <span>{data['PCT_P0020008']}%</span>
      </div>
      <div>
        <span className='d-title'>{raceLabels['P0020009']}:</span>
        <span>{data['PCT_P0020009']}%</span>
      </div>
      <div>
        <span className='d-title'>{raceLabels['P0020010']}:</span>
        <span>{data['PCT_P0020010']}%</span>
      </div>
      <div>
        <span className='d-title'>{raceLabels['P0020011']}:</span>
        <span>{data['PCT_P0020011']}%</span>
      </div>
    </div>}

    { state.ancestry?.on && data && data.TAHRPCT != 0 && <div className={`popup-race popup-header mapkey-header`} style={{backgroundColor: COUNTRY_COLORS[data.FirAHRName]}}>
      {data.NAME}
      {/* <button onClick={()=>setShowPopup(false)} className='close-btn'>X</button> */}
    </div>}
    { state.ancestry?.on && data && data.TAHRPCT != 0 && <div className='popup-body race-body mapkey-body'>
      <div>
        <span className='d-color' style={{backgroundColor: COUNTRY_COLORS[data.FirAHRName]}}></span>
        <span className='d-title'>{data.FirAHRName}:</span>
        <span>{(data.TAHRPCT * 100).toFixed(1)}%</span>
      </div>
      <div>
        <span className='d-color' style={{backgroundColor: COUNTRY_COLORS[data.SecAHRName]}}></span>
        <span className='d-title'>{data.SecAHRName}:</span>
        <span>{(parseFloat(data.SecAHR) * 100).toFixed(1)}%</span>
      </div>
      <div>
        <span className='d-color' style={{backgroundColor: COUNTRY_COLORS[data.T3AHRName]}}></span>
        <span className='d-title'>{data.T3AHRName}:</span>
        <span>{(parseFloat(data.ThirAHR) * 100).toFixed(1)}%</span>
      </div>
      <div>
        <span className='d-color' style={{backgroundColor: COUNTRY_COLORS[data.FourAHRName]}}></span>
        <span className='d-title'>{data.FourAHRName}:</span>
        <span>{(parseFloat(data.FourAHR) * 100).toFixed(1)}%</span>
      </div>
      <div>
        <span className='d-color' style={{backgroundColor: COUNTRY_COLORS[data.FifAHRName]}}></span>
        <span className='d-title'>{data.FifAHRName}:</span>
        <span>{(parseFloat(data.FifAHR) * 100).toFixed(1)}%</span>
      </div>
      <div>
        <span className='d-color' style={{backgroundColor: COUNTRY_COLORS[data.SixAHRName]}}></span>
        <span className='d-title'>{data.SixAHRName}:</span>
        <span>{(parseFloat(data.SixAHR) * 100).toFixed(1)}%</span>
      </div>
    </div>}

    {state.ancestry?.on && data && data.TAHRPCT == 0 && <div className="popup-header">"Data Unavailable for this Area"</div>}

    { state.income?.on && data && <div className={`popup-race popup-header mapkey-header`} style={{backgroundColor: getIncomeColor(data['B19049_001E'])}}>
      Median Household Income (2020)
      {/* <button onClick={()=>setShowPopup(false)} className='close-btn'>X</button> */}
    </div>}
    { state.income?.on && data && <div className='popup-body race-body mapkey-body'>
      <div>
        <span className='d-title'>Median Income:</span>
        <span>{parseFloat(data['B19049_001E']).toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
        })}</span>
      </div>
    </div>}

    { state.occupancy?.on && data && <div className={`popup-race popup-header mapkey-header`} style={{backgroundColor: getOccupancyColor(data['B25010_001E'])}}>
      Household Size
      {/* <button onClick={()=>setShowPopup(false)} className='close-btn'>X</button> */}
    </div>}
    { state.occupancy?.on && data && <div className='popup-body race-body mapkey-body'>
      <div>
        <span className='d-title'>Size:</span>
        <span>{data['B25010_001E']}</span>
      </div>
      </div>
    }
    
    </>
  )
  const FullPopupContent = ({ data }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    return (
      <div>
        {data.length > 0 && data[currentIndex].population < 100 ?
          <div className="popup-header" style={{backgroundColor: 'grey'}}>Insufficient Data</div>
          :
          <>{data.length > 0 && data[currentIndex].point_count !== 0 ? 
            <PopupContent data={data[currentIndex]} />
          : 
          //setShowPopup(false)
          <div className="popup-header">Data Unavailable for this Area</div>
          //<div className="popup-header">{data[currentIndex]?.point_count == 0 ? "No Data" : "Data Unavailable for this Area"}</div>
          }
          </>
        }
        {data.length > 1 &&
          <div className="popup-footer" style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 3, paddingRight: 20, paddingBottom: 10}}>
            <div>
              <CaretLeftOutlined style={{color: currentIndex > 0 ? 'black' : 'grey', fontSize: '20px'}} onClick={() => currentIndex > 0 && setCurrentIndex(currentIndex - 1)} />
              <CaretRightOutlined style={{color: currentIndex < data.length - 1 ? 'black' : 'grey', fontSize: '20px'}} onClick={() => currentIndex < data.length - 1 && setCurrentIndex(currentIndex + 1)} />
            </div>
            <div>
              <p style={{color: 'black', fontSize: '14px', marginBottom: 0}}>{currentIndex + 1} of {data.length}</p>
            </div>
          </div>
        }
      </div>
    )
  }
  return (
    <div style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: -1,
      }}>
      {loading && <div className='icon-loading'><ReactLoading color="rgb(165, 28, 28)" type="spin"/></div>}
      {mapLoading && <div className='icon-loading'><ReactLoading color="rgb(165, 28, 28)" type="spin"/></div>}
      {state.race?.on && <div id='race'></div>}
      {state.crime?.on && <div id='crime'></div>}
      {state.voting?.on && !state.voting2024?.on && <div id='voting'></div>}
      {state.voting?.on && state.voting2024?.on && <div id='voting2024'></div>}
      {state.ancestry?.on && <div id='ancestry'></div>}
      {state.income?.on && <div id='income'></div>}
      {state.occupancy?.on && <div id='occupancy'></div>}
      <Map
        initialViewState={{
          longitude: -100,
          latitude: 40,
          zoom: 3,
        }}
        center={center}
        // zoom={zoom}
        // zoom={zoom}
        // onClick = {(map, evt) => onClickMap(map, evt)}
        onClick={onClickMapR}
        onMouseMove={isTouchDevice ? evt => onClickMap(evt, true) : evt => throttledHover(evt, false)}
        onLoad={handleMapLoad}
        movingMethod="jumpTo"
        onZoomEnd={(map, event) => onZoom(map, event)}
        onMoveEnd={(map, event) => onZoom(map, event)}
        onViewportChange={handleViewportChange}
        ref={mapRef}
        mapStyle="mapbox://styles/mapbox/streets-v11"
        //mapboxAccessToken={'pk.eyJ1Ijoid3RnZW9ncmFwaGVyIiwiYSI6ImNrNXk3dXh6NzAwbncza3A1eHlpY2J2bmoifQ.JRy79QqtwUTYHK7dFUYy5g'}
        mapboxAccessToken={'pk.eyJ1Ijoibnl0Z3JhcGhpY3MiLCJhIjoiY2p0aXU0eHlmMnQzYjQzbzl1NTc2aDF2MyJ9.8GYtvULChE8BDJ6st6zLWA'}
        interactiveLayerIds={[
          'ancestrydata-layer',
          'mapillarysdata-point'
        ]} 
        // onClick={onClick}
      >
        {highlightedGeometry && (
          <Source
            id="highlighted-polygon"
            type="geojson"
            data={{
              type: "FeatureCollection",
              features: [highlightedGeometry]
            }}
          >
            <Layer
              id="polygon-highlight-outline"
              type="line"
              paint={{
                "line-color": "#ff0",
                "line-width": 2
              }}
            />
          </Source>
        )}
        <Source 
          id='ancestry-source' 
          type="vector"
          tiles={[`${BASE_URL}/maps/ancestry_new/{z}/{x}/{y}.mvt`]}
          maxzoom={7}
          // tiles={['http://3.20.79.56:8080/maps/ancestry/{z}/{x}/{y}.mvt']}
        >
          { state.ancestry?.on && 
            <Layer
              id='ancestrydata-layer'
              type='fill'
              source='ancestry-source'
              source-layer='ancestry'
              minZoom={7}
              maxZoom={17}
              paint={getAncestryColors(COUNTRY_COLORS, state.ancestry?.progress)}
            />
          }
        </Source>
        <Source
          id="voting_source"
          type="vector"
          tiles={[`${BASE_URL}/maps/voting/{z}/{x}/{y}.mvt`]}
          maxzoom={8}
          // tiles={['http://3.20.79.56:8080/maps/voting/{z}/{x}/{y}.mvt']}
        >
          { state.voting?.on && !state.voting2024?.on && 
            <Layer
                id="voting_layer"
                type="fill"
                source="voting_source"
                source-layer="voting"
                //source="nytgraphics.precincts2024-mkbq3tuj"
                minZoom={3}
                maxZoom={8}
                paint={{
                'fill-color': [
                    'case',
                    [">=", ["to-number", ["get", "pct_dem_lead"], 0],  70],
                    'blue',
                    [">=", ["to-number", ["get", "pct_dem_lead"], 0],  40],
                    '#4444ff',
                    [">=", ["to-number", ["get", "pct_dem_lead"], 0],  20],
                    '#7575fb',
                    [">=", ["to-number", ["get", "pct_dem_lead"], 0],  0],
                    '#a2a2f7',
                    [">=", ["to-number", ["get", "pct_dem_lead"], 0],  -20],
                    '#ff5858',
                    [">=", ["to-number", ["get", "pct_dem_lead"], 0],  -40],
                    '#ff2929',
                    [">=", ["to-number", ["get", "pct_dem_lead"], 0],  -70],
                    '#ff1210',
                    [">=", ["to-number", ["get", "pct_dem_lead"], 0],  -100],
                    'red',
                    'blue'
                ],
                'fill-opacity': 1*0.01*state.voting?.progress,
                }}
            />
          }
        </Source>
        <Source
          id="voting2024_source"
          type="vector"
          tiles={['https://api.mapbox.com/v4/nytgraphics.precincts2024-mkbq3tuj/{z}/{x}/{y}.vector.pbf?sku=101iBv9AqbqHP&access_token=pk.eyJ1Ijoibnl0Z3JhcGhpY3MiLCJhIjoiY2p0aXU0eHlmMnQzYjQzbzl1NTc2aDF2MyJ9.8GYtvULChE8BDJ6st6zLWA']}
          //tiles={[`${BASE_URL}/maps/voting2024/{z}/{x}/{y}.mvt`]}
          maxzoom={10}
          // tiles={['http://3.20.79.56:8080/maps/voting/{z}/{x}/{y}.mvt']}
        >
          { state.voting?.on && state.voting2024?.on && 
            <Layer
                id="voting2024_layer"
                type="fill"
                source="voting2024_source"
                source-layer="2024-precincts"
                minZoom={10}
                maxZoom={17}
                paint={{
                'fill-color': [
                    'case',
                    [">=", 
                        ["/",
                          ["-",
                            ["to-number", ["get", "R24"], 0],
                            ["to-number", ["get", "D24"], 0]
                          ],
                          ["to-number", ["get", "T24"], 0]
                        ], 
                        0.7
                    ],
                    'red',
                    [">=", 
                        ["/",
                          ["-",
                            ["to-number", ["get", "R24"], 0],
                            ["to-number", ["get", "D24"], 0]
                          ],
                          ["to-number", ["get", "T24"], 0]
                        ], 
                        0.4
                    ],
                    '#ff1210',
                    [">=", 
                        ["/",
                          ["-",
                            ["to-number", ["get", "R24"], 0],
                            ["to-number", ["get", "D24"], 0]
                          ],
                          ["to-number", ["get", "T24"], 0]
                        ], 
                        0.2
                    ],
                    '#ff2929',
                    [">=", 
                        ["/",
                          ["-",
                            ["to-number", ["get", "R24"], 0],
                            ["to-number", ["get", "D24"], 0]
                          ],
                          ["to-number", ["get", "T24"], 0]
                        ], 
                        0
                    ],
                    '#ff5858',
                    [">=", 
                        ["/",
                          ["-",
                            ["to-number", ["get", "R24"], 0],
                            ["to-number", ["get", "D24"], 0]
                          ],
                          ["to-number", ["get", "T24"], 0]
                        ], 
                        -0.2
                    ],
                    '#a2a2f7',
                    [">=", 
                        ["/",
                          ["-",
                            ["to-number", ["get", "R24"], 0],
                            ["to-number", ["get", "D24"], 0]
                          ],
                          ["to-number", ["get", "T24"], 0]
                        ], 
                        -0.4
                    ],
                    '#7575fb',
                    [">=", 
                        ["/",
                          ["-",
                            ["to-number", ["get", "R24"], 0],
                            ["to-number", ["get", "D24"], 0]
                          ],
                          ["to-number", ["get", "T24"], 0]
                        ], 
                        -0.7
                    ],
                    '#4444ff',
                    [">=", 
                        ["/",
                          ["-",
                            ["to-number", ["get", "R24"], 0],
                            ["to-number", ["get", "D24"], 0]
                          ],
                          ["to-number", ["get", "T24"], 0]
                        ], 
                        -1
                    ],
                    'blue',
                    'blue'
                ],
                'fill-opacity': 0.5
                }}
            />
          }
        </Source>
        <Source
          id="tract_source"
          type="vector"
          tiles={[`${BASE_URL}/maps/tract/{z}/{x}/{y}.mvt`]}
          // tiles={[`http://localhost:8080/maps/tract/{z}/{x}/{y}.mvt`]}
          maxzoom={10}
          // tiles={['http://3.20.79.56:8080/maps/voting/{z}/{x}/{y}.mvt']}
        >
          { state.crime?.on && 
            <Layer
                id="tract_layer"
                type="fill"
                source="tract_source"
                source-layer="tract"
                minZoom={10}
                maxZoom={17}
                paint={{
                'fill-color': [
                    'case',
                    ["==", ["to-number", ["get", "point_count"], 0],  0],
                    'transparent',    
                    ["<=", ["to-number", ["get", "population"], 0],  100],
                    'grey',
                    [">=", ["to-number", ["get", "severity"], 0],  24.4],
                    '#d7191c',
                    [">=", ["to-number", ["get", "severity"], 0],  14.7],
                    '#fdae61',
                    [">=", ["to-number", ["get", "severity"], 0],  7.5],
                    '#ffffc0',
                    [">=", ["to-number", ["get", "severity"], 0],  2.1],
                    '#a6d96a',
                    [">=", ["to-number", ["get", "severity"], 0],  0],
                    '#1a9641',
                    'blue'
                ],
                'fill-opacity': 1*0.01*state.crime?.progress
                }}
            />
          }
        </Source>
        <Source 
          id='mapillarysdata' 
          type="vector"
          // tiles={['http://3.20.79.56:8000/api/data/{z}/{x}/{y}.mvt']}
          tiles={[`${BASE_URL}/maps/crime/{z}/{x}/{y}.mvt`]}
          // tiles={[`${BASE_URL}/api/data/{z}/{x}/{y}.mvt`]}
        >
          { state.crime?.on && 
            <Layer
              id='mapillarysdata-point'
              type='circle'
              source='mapillarysdata'
              source-layer='crime'
              // minZoom={13}
              // maxZoom={17}
              paint={{
                'circle-color': ['match',
                  ['get', 'severity'],
                  "1.0",
                  state.crime?.property ? 'hsl(238, 89%, 58%)' : "rgba(0, 0, 255, 0)",
                  "2.0",
                  'hsl(156, 76%, 43%)',
                  "3.0",
                  'hsl(61, 77%, 54%)',
                  "4.0",
                  '#ffff79',
                  "5.0",
                  'hsl(0, 86%, 54%)',
                  'red'
                ],  //need function here to get crime category
                'circle-stroke-color': 'white',
                'circle-stroke-width': 0,
                // Transition from heatmap to circle layer by zoom level
                // 'circle-opacity': [
                //     'interpolate',
                //     ['linear'],
                //     ['zoom'],
                //     10,
                //     0,
                //     11,
                //     1*0.01*state.crime?.progress
                // ],
                'circle-radius': [
                  'interpolate',
                  ['linear'],
                  ['zoom'],
                  11,
                  5,
                  14,
                  7,
                  16,
                  9
                ]
              }}
            />
          }
        </Source>
        { state.race?.on &&
          <Source 
            id='racedata' 
            type="geojson"
            data={raceData}
          >
              <Layer
                type='fill'
                paint={{
                    'fill-color': zoom <= 14 ?['match',
                    ['get', 'maxProperty'],
                    'P0090002',
                    '#fb9902',
                    'P0090005',
                    '#78327b',
                    'P0090006',
                    '#fffe32',
                    'P0090007',
                    '#66b132',
                    'P0090008',
                    '#fe2712',
                    'P0090009',
                    '#ff00ba',
                    'P0090010',
                    '#5d4900',
                    'P0090011',
                    '#0392ce',
                    'gray'
                  ]:
                  ['match',
                    ['get', 'maxProperty'],
                    'P0020002',
                    '#fb9902',
                    'P0020005',
                    '#78327b',
                    'P0020006',
                    '#fffe32',
                    'P0020007',
                    '#66b132',
                    'P0020008',
                    '#fe2712',
                    'P0020009',
                    '#ff00ba',
                    'P0020010',
                    '#5d4900',
                    'P0020011',
                    '#0392ce',
                    'gray'
                  ],
                  'fill-opacity': 1*0.01*state.race?.progress
                }
              }
              />
          </Source>
         }
         { state.income?.on && 
            <Source 
              id='income' 
              type="geojson"
              data={incomeData}
            >
                <Layer
                  id='income'
                  type='fill'
                  minZoom={10}
                  source='income'
                  paint={{
                    'fill-color': [
                      'case',
                      [">=", ["to-number", ["get", "B19049_001E"], 0],  121000],
                      '#d6a41a',
                      [">=", ["to-number", ["get", "B19049_001E"], 0],  84800],
                      '#3a8059',
                      [">=", ["to-number", ["get", "B19049_001E"], 0],  48600],
                      '#85bf9b',
                      [">=", ["to-number", ["get", "B19049_001E"], 0],  12400],
                      '#8a8fbf',
                      [">=", ["to-number", ["get", "B19049_001E"], 0],  0],
                      '#434e96',
                      'gray'
                    ],
                    'fill-opacity': 1*0.01*state.income?.progress
                  }}
                />
            </Source>
        }
        { state.occupancy?.on && 
          <Source 
            id='occupancy' 
            type="geojson"
            data={occupancyData}
          >

              <Layer
                id='occupancy'
                type='fill'
                minZoom={10}
                source='occupancy'
                paint={{
                  'fill-color': [
                    'case',
                    [">=", ["to-number", ["get", "B25010_001E"], 0],  4],
                    '#f50000',
                    [">=", ["to-number", ["get", "B25010_001E"], 0],  3],
                    '#f53d00',
                    [">=", ["to-number", ["get", "B25010_001E"], 0],  2],
                    '#f57a00',
                    [">=", ["to-number", ["get", "B25010_001E"], 0],  1],
                    '#f5b800',
                    [">=", ["to-number", ["get", "B25010_001E"], 0],  0],
                    '#f5f500',
                    'gray'
                  ],
                  'fill-opacity': 1*0.01*state.occupancy?.progress
                }}
              />
          </Source>
        }
        { width && width > 600 && <NavigationControl className="zoom-panel" position="top-left" /> }
        <ScaleControl measurement="mi" style={{
          color: 'black'
        }} className="scale-panel"/>

        {isMarker && 
          mapRef && (
          <Marker
            map={mapRef.current}
            longitude={center[0]}
            latitude={center[1]}
          />
	)}

        {helloPopup && height > 400 && 
          <div
            className={state.crime?.on ? 'crime-box help-popup-content' : 'help-popup-content'}
          >
            <div className="help-header">
              HELLO
            </div>
            <div className="help-body">
              Explore demographics by zooming in and clicking a location, or by entering an address, city, or ZIP code.
            </div>
          </div>
        }

        {showMiniPopup &&
          <Popup 
            className="mini-popup"
            longitude={miniPopPoint[0]}
            latitude={miniPopPoint[1]}
            showPopup={showMiniPopup}
            closeButton={false}
            style={{maxWidth: state.crime?.on && miniData && miniData.length > 0 && miniData[0].id ? "350px" : "200px"}}
          >
            {/* { state.voting?.on && !state.race?.on && miniData && <div className={`popup-header ${miniData.pct_dem_lead > 0 ? 'color-blue' : 'color-red'}`}>
              Precinct: {state.voting?.on && miniData.geoid}
            </div>}

            { state.crime?.on && miniData &&  <div className={`popup-header ${SERVRITY[miniData.incident_offense_code] ? SERVRITY[miniData.incident_offense_code] : ''}`}>
              {miniData.incident_offense_code == "4" ? "Simple Assault" : miniData.incident_source_original_type}
            </div>}
            
            { state.race?.on && miniData && <div className={`popup-race popup-header ${miniData['maxProperty'] ? miniData['maxProperty'] : ''}`}>
              {raceLabels[miniData['maxProperty']]}
            </div>}

            { state.ancestry?.on && miniData && <div className={`popup-race popup-header`} style={{backgroundColor: COUNTRY_COLORS[miniData.FirAHRName]}}>
              {miniData.NAME}
            </div>}

            { state.income?.on && miniData && <div className={`popup-race popup-header`} style={{backgroundColor: getIncomeColor(miniData['B19049_001E'])}}>
              Median Household Income (2020):  <span>{parseFloat(miniData['B19049_001E']).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}</span>
            </div>}

            { state.occupancy?.on && miniData && <div className={`popup-race popup-header`} style={{backgroundColor: getOccupancyColor(miniData['B25010_001E'])}}>
              Household Size: <span>{miniData['B25010_001E']}</span>
            </div>} */}
            {miniData && miniData.length > 0 && miniData[0].population < 100 ?
              <div className="popup-header" style={{backgroundColor: 'grey'}}>Insufficient Data</div>
              :
              <>{miniData && miniData.length > 0 && miniData[0].point_count !== 0 ? 
                <MiniPopupContent data={miniData[0]} />
              :
              <div className="popup-header">{miniData[0]?.point_count == 0 ? "No Data" : "Data Unavailable for this Area"}</div>
              }
              </>
            }
          </Popup>
        }
        {showPopup &&
          <div
            className="mapboxgl-popup-content" 
            longitude={popPoint[0]}
            latitude={popPoint[1]}
            onClose={() => setShowPopup(false)}
            closeOnClick={false}
            showPopup={showPopup}
            style={{zIndex: "0 !important", position: "absolute", left: "1%", bottom: state.crime?.on ? "250px" : "100px", transform: 'none !important'}}
          >
            <p onClick={()=>setShowPopup(false)} className='close-btn' style={{color: 'black'}}>X</p>
            <FullPopupContent data={data} />
          </div>
        }
        </Map>
        {state.crime?.on &&
          <div style={{position: 'absolute', bottom: '70px', left: '20px', backgroundColor: 'white', padding: '10px', borderRadius: '5px', zIndex: '1000'}}>
            <div style={{color: 'black', padding: 0, margin: 0, lineHeight: '30px', fontWeight: 'bold'}}>Crime Key</div>
            {[1,2,3,4,5].map((item, index) => (
              <div key={index} style={{display: 'flex', alignItems: 'center', marginBottom: '5px', height: '20px'}}>
                <div style={{width: '10px', height: '10px', backgroundColor: getSeverityColor(item), margin: '5px'}} />
                <p style={{color: 'black', padding: 0, margin: 0}}>{CRIME_LEVELS[item]}</p>
              </div>
            ))}
          </div>
        }
        <img
          src="../img/streetview.png"
          className={isStreetView ? 'streetview-pegman street-active' : 'streetview-pegman'}
          onClick={toogleStreeView}
        />

        <Modal
          title="Street View"
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleOk}
          className='responsive-element'
          footer={[]}
        >
          <div>
            <LoadScript
              googleMapsApiKey="AIzaSyB_cuIJWSN9B37yAzW6i8YKdwdMO5OtM_0"
              libraries={['places']}
            >
              <GoogleMap
                key={modalRenderKey}
                mapContainerStyle={containerStyle}
                center={googleMapCenter}
                zoom={14}
              >
                <StreetViewPanorama
                  position={googleMapCenter}
                  visible={true}
                  options={{
                    pov: { heading: 100, pitch: 0 }, // POV: direction of camera
                    zoom: 1
                  }}
                />
              </GoogleMap>
            </LoadScript>
          </div>
        </Modal>
      </div>
  )

}

export default MapContainer;
